import cx from 'classnames';
import routes from '../../constants/routes';
import { t } from '../../i18n';
import { ButtonLink } from '../Button/ButtonLink';
import { Text } from '../Text/Text';

interface SidebarSubscriptionProps {
  /**
   * warning/error = bez licence (s/bez jednorázových hlasování), demo = demo režim,
   * expiring = licence končí do 30 dní, pending = čeká se na platbu proforma faktury.
   */
  type: 'warning' | 'error' | 'demo' | 'expiring' | 'pending';
  /** expiring: počet dní do konce licence */
  days?: number;
  /** pending: objednávka čekající na platbu */
  orderId?: string;
  proformaNumber?: string | null;
}

const namespace = 'Sidebar.Subscription';

export const SidebarSubscription: React.FC<SidebarSubscriptionProps> = (props) => {
  const { type = 'warning', days = 0, orderId, proformaNumber } = props;

  const message = (): string => {
    switch (type) {
      case 'expiring':
        return days <= 0 ? t('expiringToday', namespace) : t('expiring', namespace, { count: days });
      case 'pending':
        return proformaNumber ? t('pendingNumber', namespace, { number: proformaNumber }) : t('pending', namespace);
      default:
        return t(type, namespace);
    }
  };

  const action = (): { to: string; title: string } | null => {
    switch (type) {
      case 'demo':
        return null;
      case 'pending':
        return { to: `${routes.subscriptionOrder}order/${orderId}`, title: t('showOrder', namespace) };
      case 'expiring':
        return { to: routes.subscriptionOrder, title: t('extend', namespace) };
      default:
        return { to: routes.subscriptionOrder, title: t('order', namespace) };
    }
  };

  const link = action();

  return (
    <div className={cx('SidebarNotification', `SidebarNotification--${type}`)}>
      <Text className={link ? 'mb-1' : ''} color="Neutral100">
        {message()}
      </Text>
      {link && (
        <ButtonLink
          to={link.to}
          title={link.title}
          size="small"
          variant="secondary-outline"
          className="SidebarNotification__button"
          onClick={(e) => e.currentTarget?.blur()}
        />
      )}
    </div>
  );
};
